<script setup lang="ts">
import WidgetPanels from "@/components/widget/WidgetPanels.vue";
import CommonFilter from "@/components/common/CommonFilter.vue";
import CustomChildList from "@/components/custom/CustomChildList.vue";
import { useChatStore } from "@/features/chat/chat.store";

const chatStore = useChatStore();
</script>
<template>
  <div class="v-chat-child">
    <div class="main">
      <div class="main__header">
        <CommonFilter />
      </div>
      <div class="main__body">
        <div class="main__body--list">
          <CustomChildList :list="chatStore.chatList" />
        </div>
        <div class="main__body--chat"></div>
      </div>
    </div>
    <div class="aside">
      <WidgetPanels position="vertical" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.v-chat-child {
  display: flex;

  .main {
    width: 80%;

    &__header {
      padding: 16px;
      border-bottom: 1px solid var(--color-border);
    }

    &__body {
      display: flex;

      &--list {
        width: 30%;
        border-right: 1px solid var(--color-border);
        height: calc(100vh - 149px);
        overflow: auto;
      }

      &--chat {
        width: 70%;
      }
    }
  }

  .aside {
    height: calc(100vh - 72px);
    width: 20%;
    overflow: auto;
    border-left: 1px solid var(--color-border);
    padding: 16px;
  }
}
</style>
